import { Outlet } from "react-router-dom";
import ToastContainer from "@/components/snackbar-provider";
import { AuthProvider } from "@/lib/auth";
import StoreLanguageProvider from "@/services/i18n/store-language-provider";
import LeavePageProvider from "@/services/leave-page/leave-page-provider";
import ConfirmDialogProvider from "@/components/confirm-dialog/confirm-dialog-provider";
import GoogleAuthProvider from "@/services/social-auth/google/google-auth-provider";
import FacebookAuthProvider from "@/services/social-auth/facebook/facebook-auth-provider";

export default function RootLayout() {
  return (
    <StoreLanguageProvider>
      <ConfirmDialogProvider>
        <AuthProvider>
          <GoogleAuthProvider>
            <FacebookAuthProvider>
              <LeavePageProvider>
                <Outlet />
                <ToastContainer position="bottom-left" hideProgressBar />
              </LeavePageProvider>
            </FacebookAuthProvider>
          </GoogleAuthProvider>
        </AuthProvider>
      </ConfirmDialogProvider>
    </StoreLanguageProvider>
  );
}
